<template>
  <div class="new-journal">
    <div class="pc">
      <Header />
      <div class="_profile-page">
        <div class="_profile-container">
          <ColumnSettings :mode="mode" />
          <template v-if="mode !== 'default'">
            <aside class="_profile-mode-column">
              <template v-if="mode === 'change-payment-type'">
                <div class="_profile-mode-inner">
                  <div class="_profile-page-mode-info">
                    <h3 class="_profile-page-mode-title">Изменить способ оплаты</h3>
                    <p class="_profile-page-mode-text">Выберите новый способ оплаты</p>
                  </div>
                  <div class="_profile-payments-wrapper">
                    <div class="_profile-payments">
                      <div class="_profile-payment _profile-payment-mobile" @click="activateTele2">
                        <template v-if="user.payment.method !== 'tele2' || (user.payment.type !== 1 && user.payment.type !== 2)">
                          <div class="_profile-payment-grey">
                            <div class="_profile-payment-header"> <b>Оплата с мобильного</b> <img
                                src="@/assets/img/lk-mode-circle.svg" alt="circle"></div>
                            <img src="@/assets/img/lk-mode-mobile-grey.svg" alt="mobile-grey"
                              class="_profile-payment-img">
                            <span>Стоимость: 16р/день</span>
                          </div>
                        </template>
                        <template v-else>
                          <div class="_profile-payment-green">
                            <div class="_profile-payment-header"> <b>Оплата с мобильного</b> <img
                                src="@/assets/img/lk-mode-circle-active.svg" alt="circle-active"></div>
                            <img src="@/assets/img/lk-mode-mobile-green.svg" alt="mobile-green"
                              class="_profile-payment-img">
                            <span>Стоимость: 16р/день</span>
                          </div>
                        </template>
                      </div>
                      <div class="_profile-payment _profile-payment-card" @click="yaPay">
                        <template v-if="user.payment.method !== 'card' || (user.payment.type !== 1 && user.payment.type !== 2)">
                          <div class="_profile-payment-grey">
                            <div class="_profile-payment-header"> <b>Оплата<br> по карте</b> <img
                                src="@/assets/img/lk-mode-circle.svg" alt="circle"></div>
                            <img src="@/assets/img/lk-mode-credit-card-grey.svg" alt="credit-card-grey"
                              class="_profile-payment-img">
                            <span>Mastercard/VISA/МИР<br />Стоимость: 269р/месяц</span>
                          </div>
                        </template>
                        <template v-else>
                          <div class="_profile-payment-green">
                            <div class="_profile-payment-header"> <b>Оплата<br> по карте</b> <img
                                src="@/assets/img/lk-mode-circle-active.svg" alt="circle-active"></div>
                            <img src="@/assets/img/lk-mode-credit-card-green.svg" alt="credit-card-green"
                              class="_profile-payment-img">
                            <span>Mastercard/VISA/МИР<br />Стоимость: 269р/месяц</span>
                          </div>
                        </template>
                      </div>
                    </div>
                    <a @click.prevent="mode = 'default'" href="#" class="_profile-back"
                      v-if="!passwordChangeSuccess && !emailChangeSuccess && mode !== 'subscription-canceled'">
                      <img src="@/assets/img/lk-mode-back.svg" />
                      <p>Вернуться</p>
                    </a>
                  </div>
                </div>
              </template>
              <template v-if="mode === 'change-password'">
                <template v-if="passwordChangeSuccess">
                  <div class="_profile-mode-inner-success">
                    <div class="_profile-mode-inner-success-card">
                      <img class="_profile-mode-inner-success-image" src="@/assets/img/password-change-success.svg"
                        alt="Финсайт" />
                      <div class="_profile-mode-inner-success-title">
                        Пароль <br> успешно изменен!
                      </div>
                    </div>
                    <ButtonAction class="main-action-btn" type="submit" message="Закрыть"
                      @buttonAction="goDefaultProfile" />
                  </div>
                </template>
                <template v-else>
                  <div class="_profile-mode-inner change-pass">
                    <div class="_profile-page-mode-info">
                      <h3 class="_profile-page-mode-title">Изменить пароль</h3>
                      <p class="_profile-page-mode-text">Задайте новый пароль не менее 6 символов</p>
                    </div>
                    <form method="post" class="enter-form" :class="{ 'enter-form-error': passwordChangeError }"
                      autocomplete="off">
                      <div class="_profile-mode-input-group">
                        <label for="phone" class="_profile-mode-label">
                          <span v-if="passwordChangeError.message === 'Пароли не совпадают'"> Пароли не совпадают
                          </span>
                          <span v-else-if="passwordChangeError.message === 'Пароль менее 6 символов'">Пароль менее 6
                            символов</span>
                          <span v-else>Введите новый пароль</span>
                        </label>
                        <InputHideShow @setPass="setPass" :hasError="passwordChangeError" />
                      </div>
                      <div class="_profile-mode-input-group mb42">
                        <label for="phone" class="_profile-mode-label">
                          <span v-if="passwordChangeError.message === 'Пароли не совпадают'"> Пароли не совпадают
                          </span>
                          <span v-else-if="passwordChangeError.message === 'Пароль менее 6 символов'">Пароль менее 6
                            символов</span>
                          <span v-else>Введите новый пароль еще раз</span>
                        </label>
                        <InputHideShow @setPass="setPassConfirm" :hasError="passwordChangeError" />
                      </div>
                      <ButtonAction class="main-action-btn" type="submit" :message="passwordChangeError.btn"
                        @buttonAction="changePassword" />
                      <a @click.prevent="mode = 'default'" href="#" class="_profile-back"
                        v-if="!passwordChangeSuccess && !emailChangeSuccess && mode !== 'subscription-canceled'">
                        <img src="@/assets/img/lk-mode-back.svg" />
                        <p>Вернуться</p>
                      </a>
                    </form>
                  </div>
                </template>
              </template>
              <template v-if="mode === 'email-control'">
                <template v-if="emailChangeSuccess">
                  <div class="_profile-mode-inner-success">
                    <div class="_profile-mode-inner-success-card">
                      <img class="_profile-mode-inner-success-image" src="@/assets/img/password-change-success.svg"
                        alt="Финсайт" />
                      <div class="_profile-mode-inner-success-title">
                        E-mail <br> успешно изменен!
                      </div>
                    </div>
                    <ButtonAction class="main-action-btn" type="submit" message="Закрыть"
                      @buttonAction="goDefaultProfile" />
                  </div>
                </template>
                <template v-else>
                  <div class="_profile-mode-inner email-control">
                    <div class="_profile-page-mode-info">
                      <h3 class="_profile-page-mode-title">Управление E-mail</h3>
                      <p class="_profile-page-mode-text">Для просмотра писем перейдите в почту или добавьте свой
                        e-mail
                      </p>
                    </div>
                    <form method="post" class="enter-form" :class="{ 'enter-form-error': emailChangeError }"
                      autocomplete="off">
                      <a class="_profile-go-to-mail" target="_blank" :href="emailLink">
                        <div class="btn-go-to-mail">
                          <img src="@/assets/img/message-icon.svg" alt="message">
                          <span class="text">Перейти в почту</span>
                          <img class="_profile-nav-arr" src="@/assets/img/lk-menu-arrow.svg" alt="arrow">
                        </div>
                      </a>
                      <div class="_profile-mode-input-group">
                        <label for="phone" class="_profile-mode-label">
                          <span v-if="emailChangeError.message === 'E-mail не совпадает'"> E-mail не совпадает </span>
                          <span v-else-if="emailChangeError.message === 'Некорректный e-mail'"> Некорректный e-mail
                          </span>
                          <span v-else>Задайте новый e-mail</span>
                        </label>
                        <input placeholder="Ваш E-mail" type="text" name="email_q" v-model="newEmail"
                          class="_profile-mode-input" />
                      </div>
                      <div class="_profile-mode-input-group mb22">
                        <label for="phone" class="_profile-mode-label">
                          <span v-if="emailChangeError.message === 'E-mail не совпадает'"> E-mail не совпадает </span>
                          <span v-else-if="emailChangeError.message === 'Некорректный e-mail'"> Некорректный e-mail
                          </span>
                          <span v-else>Введите новый e-mail еще раз</span>
                        </label>
                        <input placeholder="E-mail еще раз" type="text" name="email_s" v-model="newEmailConfirm"
                          class="_profile-mode-input" />
                      </div>
                      <ButtonAction type="submit" :message="emailChangeError.btn" class="main-action-btn"
                        @buttonAction="changeEmail" />
                      <a @click.prevent="mode = 'default'" href="#" class="_profile-back"
                        v-if="!passwordChangeSuccess && !emailChangeSuccess && mode !== 'subscription-canceled'">
                        <img src="@/assets/img/lk-mode-back.svg" />
                        <p>Вернуться</p>
                      </a>
                    </form>
                  </div>
                </template>
              </template>
              <template v-if="mode === 'confirm-cancel-subscription'">
                <div class="_profile-mode-inner cancel-sub">
                  <div class="_profile-page-mode-info">
                    <h3 class="_profile-page-mode-title">Отключить услугу</h3>
                    <p class="_profile-page-mode-text">В этом случае доступ к разделам приостановится</p>
                  </div>
                  <div class="_profile-page-mode-form-block">
                    <h2 class="_profile-page-mode-confirm-title">Вы уверены, что хотите приостановить доступ <br>к
                      журналу?</h2>
                    <ButtonAction class="main-action-btn" type="submit" message="Я передумал"
                      @buttonAction="goDefaultProfile" />
                    <ButtonAction class="main-action-btn main-action-btn-grey" type="submit" message="Отключить"
                      @buttonAction="doCancelSubscription" />
                  </div>
                </div>
              </template>
              <template v-if="mode === 'confirm-cancel-subscription-inv'">
                <div class="_profile-mode-inner cancel-sub">
                  <div class="_profile-page-mode-info">
                    <h3 class="_profile-page-mode-title">Отключить услугу</h3>
                    <p class="_profile-page-mode-text">В этом случае доступ к разделам приостановится</p>
                  </div>
                  <div class="_profile-page-mode-form-block">
                    <h2 class="_profile-page-mode-confirm-title">Вы уверены, что хотите приостановить доступ <br>к
                      инвестициям?</h2>
                    <ButtonAction class="main-action-btn" type="submit" message="Я передумал"
                      @buttonAction="goDefaultProfile" />
                    <ButtonAction class="main-action-btn main-action-btn-grey" type="submit" message="Отключить"
                      @buttonAction="doCancelSubscriptionInv" />
                  </div>
                </div>
              </template>
              <template v-if="mode === 'subscription-canceled'">
                <div class="_profile-mode-inner-success">
                  <div class="_profile-mode-inner-success-card">
                    <img class="_profile-mode-inner-success-image" src="@/assets/img/password-change-success.svg"
                      alt="Финсайт" />
                    <div class="_profile-mode-inner-success-title">
                      Услуга <br> успешно отключена!
                    </div>
                  </div>
                  <ButtonAction class="main-action-btn" type="submit" message="Закрыть"
                    @buttonAction="goDefaultProfile" />
                </div>
              </template>
              <template v-if="mode === 'yandex-pay-success'">
                <div class="_profile-mode-inner-success">
                  <img class="_profile-mode-inner-success-image" src="@/assets/img/profile-check.svg" alt="Финсайт" />
                  <div class="_profile-mode-inner-success-title">
                    Оплата прошла успешно
                  </div>

                  <router-link to="/" class="_profile-btn _profile-btn-gradient">Перейти к чтению !</router-link>
                  <div style="margin-bottom: 23px; margin-top: 31px; text-align: center;">
                    <img src="@/assets/images/profile-img.svg" alt="Финсайт" />
                  </div>

                  <a href="/profile" @click.prevent="
                    mode = 'default';
                  removeHash();
                  " class="_profile-btn _profile-btn-blue" style="margin-bottom: 12px;">Обратно в личный
                    кабинет</a>
                </div>
              </template>
            </aside>
          </template>
          <template v-else>
            <ColumnSubscriptions
                :mode="mode"
                @activateJournalSubscription="activateTele2"
                @activateInvestSubscription="activateInvestSubscription"
            />
          </template>
          <ColumnData :mode="mode" />
        </div>
      </div>
      <Footer />
    </div>

    <div class="phone">
      <template v-if="mode === 'default'">
        <Header />
        <div class="_profile-page">
          <div class="_profile-container">
            <ColumnSettings :mode="mode" />
            <ColumnSubscriptions
                :mode="mode"
                @activateJournalSubscription="activateTele2"
                @activateInvestSubscription="activateInvestSubscription"
            />
            <ColumnData :mode="mode" />
          </div>
        </div>
        <Footer />
      </template>

      <template v-if="mode !== 'default'">
        <div>
          <div class="_profile-wrapper">
            <Header :mobHasMenu="false" />
            <div class="container">
              <a @click.prevent="mode = 'default'" href="#" class="_profile-back"
                v-if="!passwordChangeSuccess && !emailChangeSuccess && mode !== 'subscription-canceled'">
                <img src="@/assets/img/lk-mode-back.svg" />
                <p>Вернуться</p>
              </a>
              <template v-if="mode === 'change-payment-type'">
                <div class="_profile-mode-inner">
                  <div class="_profile-page-mode-info">
                    <h3 class="_profile-page-mode-title">Изменить способ оплаты</h3>
                    <p class="_profile-page-mode-text">Выберите новый способ оплаты</p>
                  </div>
                  <div class="_profile-payments">
                    <div class="_profile-payment _profile-payment-mobile" @click="activateTele2">
                      <template v-if="user.payment.method !== 'tele2'">
                        <div class="_profile-payment-grey">
                          <div class="_profile-payment-header"> <b>Оплата с мобильного</b> <img
                              src="@/assets/img/lk-mode-circle.svg" alt="circle"></div>
                          <img src="@/assets/img/lk-mode-mobile-grey.svg" alt="mobile-grey" class="_profile-payment-img">
                          <span>Стоимость: 16р/день</span>
                        </div>
                      </template>
                      <template v-else>
                        <div class="_profile-payment-green">
                          <div class="_profile-payment-header"> <b>Оплата с мобильного</b> <img
                              src="@/assets/img/lk-mode-circle-active.svg" alt="circle-active"></div>
                          <img src="@/assets/img/lk-mode-mobile-green.svg" alt="mobile-green"
                            class="_profile-payment-img">
                          <span>Стоимость: 16р/день</span>
                        </div>
                      </template>
                    </div>
                    <div class="_profile-payment _profile-payment-card" @click="yaPay">
                      <template v-if="user.payment.method !== 'card'">
                        <div class="_profile-payment-grey">
                          <div class="_profile-payment-header"> <b>Оплата<br> по карте</b> <img
                              src="@/assets/img/lk-mode-circle.svg" alt="circle"></div>
                          <img src="@/assets/img/lk-mode-credit-card-grey.svg" alt="credit-card-grey"
                            class="_profile-payment-img">
                          <span>Mastercard/VISA/МИР<br />Стоимость: 269р/месяц</span>
                        </div>
                      </template>
                      <template v-else>
                        <div class="_profile-payment-green">
                          <div class="_profile-payment-header"> <b>Оплата<br> по карте</b> <img
                              src="@/assets/img/lk-mode-circle-active.svg" alt="circle-active"></div>
                          <img src="@/assets/img/lk-mode-credit-card-green.svg" alt="credit-card-green"
                            class="_profile-payment-img">
                          <span>Mastercard/VISA/МИР<br />Стоимость: 269р/месяц</span>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
              </template>
              <template v-if="mode === 'change-password'">
                <template v-if="passwordChangeSuccess">
                  <div class="_profile-mode-inner-success">
                    <div class="_profile-mode-inner-success-card">
                      <img class="_profile-mode-inner-success-image" src="@/assets/img/password-change-success.svg"
                        alt="Финсайт" />
                      <div class="_profile-mode-inner-success-title">
                        Пароль успешно изменен!
                      </div>
                    </div>
                    <ButtonAction class="main-action-btn" type="submit" message="Закрыть"
                      @buttonAction="goDefaultProfile" />
                  </div>
                </template>
                <template v-else>
                  <div class="_profile-mode-inner change-pass">
                    <div class="_profile-page-mode-info">
                      <h3 class="_profile-page-mode-title">Изменить пароль</h3>
                      <p class="_profile-page-mode-text">Задайте новый пароль не менее 6 символов</p>
                    </div>
                    <form method="post" class="enter-form" :class="{ 'enter-form-error': passwordChangeError }"
                      autocomplete="off">
                      <div class="_profile-mode-input-group">
                        <label for="phone" class="_profile-mode-label">
                          <span v-if="passwordChangeError.message === 'Пароли не совпадают'"> Пароли не совпадают
                          </span>
                          <span v-else-if="passwordChangeError.message === 'Пароль менее 6 символов'">Пароль менее 6
                            символов</span>
                          <span v-else>Введите новый пароль</span>
                        </label>
                        <InputHideShow @setPass="setPass" :hasError="passwordChangeError" />
                      </div>
                      <div class="_profile-mode-input-group mb35">
                        <label for="phone" class="_profile-mode-label">
                          <span v-if="passwordChangeError.message === 'Пароли не совпадают'"> Пароли не совпадают
                          </span>
                          <span v-else-if="passwordChangeError.message === 'Пароль менее 6 символов'">Пароль менее 6
                            символов</span>
                          <span v-else>Введите новый пароль еще раз</span>
                        </label>
                        <InputHideShow @setPass="setPassConfirm" :hasError="passwordChangeError" />
                      </div>
                      <ButtonAction class="main-action-btn" type="submit" :message="passwordChangeError.btn"
                        @buttonAction="changePassword" />
                    </form>
                  </div>
                </template>
              </template>
              <template v-if="mode === 'email-control'">
                <template v-if="emailChangeSuccess">
                  <div class="_profile-mode-inner-success">
                    <div class="_profile-mode-inner-success-card">
                      <img class="_profile-mode-inner-success-image" src="@/assets/img/password-change-success.svg"
                        alt="Финсайт" />
                      <div class="_profile-mode-inner-success-title">
                        E-mail успешно изменен!
                      </div>
                    </div>
                    <ButtonAction class="main-action-btn" type="submit" message="Закрыть"
                      @buttonAction="goDefaultProfile" />
                  </div>
                </template>
                <template v-else>
                  <div class="_profile-mode-inner email-control">
                    <div class="_profile-page-mode-info">
                      <h3 class="_profile-page-mode-title">Управление E-mail</h3>
                      <p class="_profile-page-mode-text">Для просмотра писем перейдите в почту или добавьте свой e-mail
                      </p>
                    </div>
                    <form method="post" class="enter-form" :class="{ 'enter-form-error': emailChangeError }"
                      autocomplete="off">
                      <a class="_profile-go-to-mail" target="_blank" :href="emailLink">
                        <div class="btn-go-to-mail">
                          <img src="@/assets/img/message-icon.svg" alt="message">
                          <span class="text">Перейти в почту</span>
                          <img class="_profile-nav-arr" src="@/assets/img/lk-menu-arrow.svg" alt="arrow">
                        </div>
                      </a>
                      <div class="_profile-mode-input-group">
                        <label for="phone" class="_profile-mode-label">
                          <span v-if="emailChangeError.message === 'E-mail не совпадает'"> E-mail не совпадает </span>
                          <span v-else-if="emailChangeError.message === 'Некорректный e-mail'"> Некорректный e-mail
                          </span>
                          <span v-else>Задайте новый e-mail</span>
                        </label>
                        <input placeholder="Ваш E-mail" type="text" name="email_q" v-model="newEmail"
                          class="_profile-mode-input" />
                      </div>
                      <div class="_profile-mode-input-group mb35">
                        <label for="phone" class="_profile-mode-label">
                          <span v-if="emailChangeError.message === 'E-mail не совпадает'"> E-mail не совпадает </span>
                          <span v-else-if="emailChangeError.message === 'Некорректный e-mail'"> Некорректный e-mail
                          </span>
                          <span v-else>Введите новый e-mail еще раз</span>
                        </label>
                        <input placeholder="E-mail еще раз" type="text" name="email_s" v-model="newEmailConfirm"
                          class="_profile-mode-input" />
                      </div>
                      <ButtonAction type="submit" :message="emailChangeError.btn" class="main-action-btn"
                        @buttonAction="changeEmail" />
                    </form>
                  </div>
                </template>
              </template>
              <template v-if="mode === 'confirm-cancel-subscription'">
                <div class="_profile-mode-inner cancel-sub">
                  <div class="_profile-page-mode-info ">
                    <h3 class="_profile-page-mode-title">Отключить услугу</h3>
                    <p class="_profile-page-mode-text">В этом случае доступ к разделам приостановится</p>
                  </div>
                  <div class="_profile-page-mode-confirm-title">
                    Вы уверены, что хотите приостановить доступ <br>к журналу?
                  </div>
                  <ButtonAction class="main-action-btn" type="submit" message="Я передумал"
                    @buttonAction="goDefaultProfile" />
                  <ButtonAction class="main-action-btn main-action-btn-grey" type="submit" message="Отключить"
                    @buttonAction="doCancelSubscription" />
                </div>
              </template>
              <template v-if="mode === 'confirm-cancel-subscription-inv'">
                <div class="_profile-mode-inner cancel-sub">
                  <div class="_profile-page-mode-info">
                    <h3 class="_profile-page-mode-title">Отключить услугу</h3>
                    <p class="_profile-page-mode-text">В этом случае доступ к разделам приостановится</p>
                  </div>
                  <div class="_profile-page-mode-confirm-title">
                    Вы уверены, что хотите приостановить доступ <br>к инвестициям?
                  </div>
                  <ButtonAction class="main-action-btn" type="submit" message="Я передумал"
                    @buttonAction="goDefaultProfile" />
                  <ButtonAction class="main-action-btn main-action-btn-grey" type="submit" message="Отключить"
                    @buttonAction="doCancelSubscriptionInv" />
                </div>
              </template>
              <template v-if="mode === 'subscription-canceled'">
                <div class="_profile-mode-inner-success">
                  <div class="_profile-mode-inner-success-card">
                    <img class="_profile-mode-inner-success-image" src="@/assets/img/password-change-success.svg"
                      alt="Финсайт" />
                    <div class="_profile-mode-inner-success-title">
                      Услуга успешно отключена!
                    </div>
                  </div>
                  <ButtonAction class="main-action-btn" type="submit" message="Закрыть"
                    @buttonAction="goDefaultProfile" />
                </div>
              </template>
              <template v-if="mode === 'change-payment-type1'">
                <div class="_profile-phone-number-label">Ваш номер телефона</div>
                <div class="_profile-phone-number">{{ user.phone.formatted }}</div>
                <div class="_profile-payments">
                  <div class="_profile-payment _profile-payment-mobile" @click="activateTele2">
                    <mobile-gray v-if="user.payment.method !== 'tele2'" />
                    <mobile-active v-else-if="user.payment.method === 'tele2'" />
                    <mobile v-else />
                    <div>
                      <template v-if="user.payment.method !== 'tele2'">
                        <b>Оплата с мобильного</b>
                        <span>Только для абонентов Теле2<br />Стоимость: 12р /
                          день</span>
                      </template>
                      <template v-else>
                        <b>Оплата с мобильного</b>
                        <span>Подписка активна<br />Стоимость: 12р / день</span>
                      </template>
                    </div>
                  </div>
                  <div class="_profile-payment _profile-payment-card" @click="yaPay">
                    <card-gray v-if="user.payment.method !== 'card'" />
                    <card-active v-else-if="user.payment.method === 'card'" />
                    <card v-else />
                    <div>
                      <template v-if="user.payment.method !== 'card'">
                        <b>Оплата по карте</b>
                        <span>Mastercard/VISA/МИР<br />Стоимость: 269р/месяц</span>
                      </template>
                      <template v-else>
                        <b>Отключить автоплатеж</b>
                        <span>Подписка активна<br />Стоимость: 269р/месяц</span>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="_profile-back">
                  <a @click.prevent=" mode = 'default'" href="#">Вернуться назад</a>
                </div>
              </template>
              <template v-if="mode === 'confirm-card-cancel-subscription'">
                <div class="_profile-mode-inner-success">
                  <div class="_profile-mode-inner-success-title">
                    Уверены, что хотите отвязать карту?
                  </div>
                  <a href="#" @click.prevent=" mode = 'change-payment-type'" class="_profile-btn _profile-btn-blue"
                    style="margin-bottom: 12px;">Нет, я случайно</a>
                  <a href="#" @click.prevent="cancelSubscriptionCard" class="_profile-btn _profile-btn-outline">Да,
                    отвязать</a>
                </div>
              </template>
              <template v-if="mode === 'subscription-card-canceled'">
                <div class="_profile-mode-inner-success">
                  <img class="_profile-mode-inner-success-image" src="@/assets/img/heart.svg" alt="Финсайт" />
                  <div class="_profile-mode-inner-success-title">
                    Мы будем ждать тебя обратно!
                  </div>
                  <a href="#" @click.prevent=" mode = 'change-payment-type'" class="_profile-btn _profile-btn-blue"
                    style="margin-bottom: 12px;">Я передумал!</a>
                  <div class="___desc" style="margin-bottom: 60px;">
                    Карта успешно отвязана, Подписка действует до конца оплаченного
                    периода
                  </div>
                  <div class="_profile-back">
                    <router-link to="/">Вернуться на главную страницу</router-link>
                  </div>
                </div>
              </template>
              <template v-if="mode === 'yandex-pay-success'">
                <div class="_profile-mode-inner-success">
                  <img class="_profile-mode-inner-success-image" src="@/assets/img/profile-check.svg" alt="Финсайт" />
                  <div class="_profile-mode-inner-success-title">
                    Оплата прошла успешно
                  </div>

                  <router-link to="/" class="_profile-btn _profile-btn-gradient">Перейти к чтению !</router-link>
                  <div style="margin-bottom: 23px; margin-top: 31px; text-align: center;">
                    <img src="@/assets/images/profile-img.svg" alt="Финсайт" />
                  </div>

                  <a href="/profile" @click.prevent="
                    mode = 'default';
                  removeHash();
                  " class="_profile-btn _profile-btn-blue" style="margin-bottom: 12px;">Обратно в личный кабинет</a>
                </div>
              </template>
            </div>
            <Footer :onlyCopyright="true" />
          </div>
        </div>
      </template>
    </div>

  </div>
</template>

<script>
import eventsBus from "@/api/events";
import request from "@/api/axios";
import Header from "@/components/newRedesign/HeaderNewCopy";
import Footer from "@/components/newRedesign/FooterNewCopy";
import Card from "@/components/base/icons/Card";
import CardActive from "@/components/base/icons/CardActive";
import CardGray from "@/components/base/icons/CardGray";
import Mobile from "@/components/base/icons/Mobile";
import MobileActive from "@/components/base/icons/MobileActive";
import MobileGray from "@/components/base/icons/MobileGray";
import ColumnSettings from "@/components/newRedesign/pages/Profile/ColumnSettings";
import ColumnSubscriptions from "@/components/newRedesign/pages/Profile/ColumnSubscriptions";
import ColumnData from "@/components/newRedesign/pages/Profile/ColumnData";
import InputHideShow from "@/components/newRedesign/UI/InputHideShow";
import ButtonAction from "@/components/newRedesign/UI/ButtonAction";

export default {
  components: {
    Header,
    Footer,
    Card,
    CardActive,
    CardGray,
    Mobile,
    MobileActive,
    MobileGray,
    ColumnSettings,
    ColumnSubscriptions,
    ColumnData,
    InputHideShow,
    ButtonAction,
  },
  data: () => {
    return {
      hashes: [
        "#change-password",
        "#change-payment-type",
        "#email-control",
        "#email-control-success",
        "#email-control-change",
        "#confirm-cancel-subscription",
        "#confirm-cancel-subscription-inv",
      ],
      emailLink: false,
      mode: "default",
      password: "",
      passwordConfirm: "",
      passwordChangeSuccess: false,
      passwordChangeError: false,
      passwordChangePreload: false,
      newEmail: "",
      newEmailConfirm: "",
      emailChangeSuccess: false,
      emailChangeError: false,
      emailChangePreload: false,
      showMenu: true,
      showPassword: false,
      showPasswordConfirm: false,
    };
  },
  mounted() {
    eventsBus.$emit("page-ready");
    this.checkHash();
    window.addEventListener("hashchange", this.checkHash, false);
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
  },
  watch: {
    mode(val) {
      let hash = window.location.hash;
      if (hash) {
        const foundIndex = this.hashes.indexOf(hash);
        if (foundIndex > -1) {
          if ("#" + val !== hash) {
            this.removeHash();
          }
        }
      }
    },

    user: {
      handler: function (val) {
        if (!val || !val.phone) this.logout();
      },
      deep: true,
      immediate: true,
    },

    password: function () {
      this.passwordChangeError = false;
    },
    passwordConfirm: function () {
      this.passwordChangeError = false;
    },
    newEmail: function () {
      this.emailChangeError = false;
    },
    newEmailConfirm: function () {
      this.emailChangeError = false;
    },
  },
  methods: {
    async setEmailLink() {
      const mailLink = (await request({ action: "get_link_to_mail" })).data;
      this.emailLink = mailLink.link;
    },
    validateEmail(email) {
      const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    async changeEmail() {
      if (this.emailChangePreload) return false;
      this.emailChangePreload = true;

      if (!this.validateEmail(this.newEmail)) {
        this.emailChangeError = { message: "Некорректный e-mail", btn: "Попробовать еще раз" };
        this.emailChangePreload = false;
        return false;
      }

      if (this.newEmail !== this.newEmailConfirm) {
        this.emailChangeError = { message: "E-mail не совпадает", btn: "Попробовать еще раз" };
        this.emailChangePreload = false;
        return false;
      }

      let response = await request({
        action: "change_email",
        options: { email: this.newEmail },
      });

      this.emailChangePreload = false;

      if (response?.data?.status === true) {
        await this.setEmailLink();
        this.$store.commit("login", response.data.user);
        this.emailChangeSuccess = true;
      }
    },
    removeHash() {
      this.emailChangeSuccess = false;
      history.pushState(
        "",
        document.title,
        window.location.pathname + window.location.search
      );
      this.showMenu = true
    },
    checkHash() {
      let hash = window.location.hash;
      if (hash) {
        if (this.hashes.includes(hash)) this.mode = hash.replace("#", "");
        this.showMenu = false
      } else {
        this.mode = "default";
        this.emailChangeSuccess = false;
        this.showMenu = true
      }
    },
    async changePassword() {
      if (this.passwordChangePreload) return false;
      this.passwordChangePreload = true;

      if (this.password !== this.passwordConfirm) {
        this.passwordChangeError = { message: "Пароли не совпадают", btn: "Попробовать еще раз" };
        this.passwordChangePreload = false;
        return false;
      }

      if (this.password.length < 6 || this.passwordConfirm.length < 6) {
        this.passwordChangeError = { message: "Пароль менее 6 символов", btn: "Попробовать еще раз" };
        this.passwordChangePreload = false;
        return false;
      }

      let response = await request({
        action: "change_password",
        options: {
          phone: this.user.phone.original,
          password: this.password,
        },
      });

      this.passwordChangePreload = false;

      if (response?.data?.status === true) {
        this.passwordChangeSuccess = true;
      }

    },
    async changePasswordEmail() {
      if (this.passwordChangePreload) return false;
      this.passwordChangePreload = true;

      if (!this.password) {
        this.passwordChangeError = { message: "Введите пароль" };
        this.passwordChangePreload = false;
        return false;
      }

      if (!this.passwordConfirm) {
        this.passwordChangeError = { message: "Подтвердите пароль" };
        this.passwordChangePreload = false;
        return false;
      }

      if (this.password !== this.passwordConfirm) {
        this.passwordChangeError = { message: "Ошибка подтверждения пароля" };
        this.passwordChangePreload = false;
        return false;
      }

      this.passwordChangePreload = false;
    },

    async yaPay() {
      if (this.user.payment.method !== 'card' || this.user.payment.method !== 1) {
        this.$router.push({
          name: 'promo',
          params: { yaPayWidget: true },
        });
      } else {
        this.mode = "confirm-card-cancel-subscription";
      }
    },
    activateTele2() {
      if (this.user.payment.method === 'tele2' && this.user.payment.method === 1) return false;
      this.$router.push({
        name: 'promo',
        params: {
          activateTele2: true,
          phone: this.user.phone.formatted,
        },
      });
    },
    activateInvestSubscription() {
      this.$router.push({
        name: "promo-invest",
        params: {
          activateTele2: true,
          phone: this.user.phone.formatted,
        },
      });
    },
    async doCancelSubscription() {
      await request({ action: 'cancel' });
      await this.$store.dispatch('getUser');
      this.mode = 'subscription-canceled';
      this.$router.push('/profile')
    },
    async doCancelSubscriptionInv() {
      await request({ action: 'cancel_inv' });
      await this.$store.dispatch('getUser');
      this.mode = 'subscription-canceled';
      this.$router.push('/profile')
    },
    async cancelSubscriptionCard() {
      await request({ action: 'cancel_other' });
      await this.$store.dispatch('getUser');
      this.mode = 'subscription-card-canceled';
    },
    toggleShow() {
      this.showPassword = !this.showPassword;
    },
    toggleShowConfirm() {
      this.showPasswordConfirm = !this.showPasswordConfirm;
    },
    setPass(pass) {
      this.password = pass;
    },
    setPassConfirm(pass) {
      this.passwordConfirm = pass;
    },
    goDefaultProfile() {
      this.mode = 'default';
      this.$router.push('/profile');
    },
  },
  async created() {
    document.body.classList.remove('active-menu');
    if (this.$route.params.changePaymentMode === true) {
      this.mode = 'change-payment-type';
    }
    if (!this.user) this.logout();
    await this.setEmailLink();
  },
};
</script>

<style lang="scss">
.phone {
  display: none;
}

.___desc {
  font-family: Gilroy;
  text-align: left;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 14px;
  color: #828282;
}

._profile-page {
  position: relative;
  margin-bottom: 90px;
}

._profile-container {
  display: flex;
  justify-content: space-between;
  max-width: 1232px;
  margin: auto;
}

._profile-wrapper {
  display: flex;
  flex-direction: column;
  height: 100%;

  ._profile-container {
    flex: 1 0 auto;
  }

  ._profile-mode-inner {
    flex: 1 0 auto;
  }
}

ul._profile-nav {
  li {
    margin-bottom: 11px;

    a {
      display: flex;
      align-items: center;
      justify-content: space-between;
      position: relative;

      img {
        position: absolute;
      }

      span {
        padding-left: 27px;
        font-family: 'Gilroy';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 17px;
        color: #4F4F4F;
        text-decoration: none;
      }

      ._profile-nav-arr {
        position: relative;
      }
    }
  }

  li:last-child {
    margin-bottom: 0;
  }
}

._profile-mode-column {
  width: 667px;
  padding: 158px 0 0 199px;

  ._profile-mode-inner {
    margin: 0;
    padding: 0;

    ._profile-page-mode-info {
      padding-bottom: 45px;
      color: #4F4F4F;

      ._profile-page-mode-title {
        width: 250px;
        font-size: 18px;
        font-family: Gilroy;
        font-style: normal;
        font-weight: 600;
        line-height: 125%;
        border-bottom: 1px solid #4F4F4F;
      }

      ._profile-page-mode-text {
        font-size: 12px;
        font-family: Circe;
        font-style: normal;
        font-weight: 400;
        line-height: 120%;
      }
    }

    ._profile-page-mode-form-block {
      width: 248px;

      ._profile-page-mode-confirm-title {
        margin-bottom: 30px;
        color: #333;
        font-size: 20px;
        font-family: Gilroy;
        font-weight: 700;
        line-height: 130%;
      }
    }

    ._profile-back {
      display: flex;
      text-align: center;
      justify-content: center;
      padding-top: 30px;

      p {
        padding-left: 5px;
        color: #4F4F4F;
        font-size: 14px;
        font-weight: 400;
        line-height: 140%;
        text-decoration-line: underline;
      }
    }

    ._profile-payments-wrapper {
      width: 324px;

      ._profile-payments {
        display: flex;
        justify-content: space-between;

        ._profile-payment {
          width: 152px;
          height: 217px;
          border-radius: 8px;
          font-family: Gilroy;
          font-style: normal;
          cursor: pointer;

          &-header {
            position: relative;
            margin-bottom: 20px;

            b {
              font-size: 18px;
              font-weight: 500;
              line-height: normal;
            }

            img {
              position: absolute;
              top: 3px;
              right: 0;
            }
          }

          ._profile-payment-img {
            display: flex;
            align-self: end;
            width: 95px;
            height: 95px;
            margin-bottom: 20px;
          }

          span {
            font-size: 11px;
            font-weight: 400;
            line-height: 12px;
          }

          ._profile-payment-grey {
            padding-inline: 11px 13px;
            padding-block: 6px 9px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            color: #333;
            background-color: #F2F2F2;
            border-radius: 8px;
            border: 2px solid #22B491;
          }

          ._profile-payment-green {
            padding-inline: 11px 13px;
            padding-block: 6px 9px;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            color: #F2F2F2;
            background-color: #22B491;
            border-radius: 8px;
          }
        }

        ._profile-payment-mobile {
          ._profile-payment-img {
            align-self: start;
            width: 70px;
            height: 70px;
          }
        }
      }
    }

    .enter-form {
      width: 248px;
    }

    ._profile-mode-input-group {
      margin-bottom: 20px;

      ._profile-mode-label {
        margin-bottom: 0;
        color: #828282;
        font-size: 12px;
        font-family: Circe;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
      }

      input {
        display: flex;
        text-align: center;
        width: 100%;
        padding: 14px;
        font-size: 16px;
        font-family: Gilroy;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 8px;
        border: 1px solid #22B491;
        outline: none;
        box-shadow: none;
        -webkit-appearance: none;
      }

      input::placeholder {
        color: #BDBDBD;
      }
    }

    ._profile-mode-input-group.mb42 {
      margin-bottom: 42px;
    }



    .enter-form-error {
      ._profile-mode-input {
        border: 1px solid #CF2F38;
      }
    }

    ._profile-go-to-mail {
      cursor: pointer;

      .btn-go-to-mail {
        width: 100%;
        height: 48px;
        padding-inline: 15px;
        margin-bottom: 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px;
        border: 1px solid #4F4F4F;

        span {
          color: #4F4F4F;
          font-family: Gilroy;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 140%;
        }
      }
    }
  }

  ._profile-mode-inner-success {
    width: 248px;
    padding-top: 56px;
    text-align: center;

    ._profile-mode-inner-success-card {
      height: 170px;
      margin-bottom: 78px;
      padding: 25px 0 27px;
      border-radius: 8px;
      background: #E4EEFF;

      ._profile-mode-inner-success-image {
        width: 60px;
        height: 60px;
        margin-bottom: 14px;
      }

      ._profile-mode-inner-success-title {
        color: #2F80ED;
        text-align: center;
        font-size: 18px;
        font-family: Gilroy;
        font-weight: 700;
        line-height: 120%;
      }
    }
  }


  ._profile-mode-inner.email-control {
    width: 248px;

    ._profile-page-mode-info {
      padding-bottom: 23px;
    }

    ._profile-mode-input-group {
      margin-bottom: 10px;
    }

    .mb22 {
      margin-bottom: 22px;
    }
  }
}

@media screen and (max-width: 725px) {
  .pc {
    display: none;
  }

  .phone {
    display: block;
  }

  ._profile-page {
    display: flex;
    justify-content: center;
    padding-top: 190px;
    margin-bottom: 40px;
  }

  ._profile-container {
    flex-direction: column;
    width: 314px;
  }

  .container {
    flex-direction: column;
    width: 314px;
    flex: 1 0 auto;

    ._profile-back {
      margin-top: 106px;
      display: flex;
      text-align: start;

      p {
        padding-left: 5px;
        color: #4F4F4F;
        font-size: 14px;
        font-weight: 400;
        line-height: 140%;
        text-decoration-line: underline;
      }
    }
  }

  ._profile-page-mode-info {
    text-align: start;
    padding-bottom: 65px;
    color: #4F4F4F;

    ._profile-page-mode-title {
      margin-bottom: 5px;
      width: 250px;
      font-size: 18px;
      font-family: Gilroy;
      font-style: normal;
      font-weight: 600;
      line-height: 140%;
      border-bottom: 1px solid #4F4F4F;
    }

    ._profile-page-mode-text {
      font-size: 14px;
      font-family: Circe;
      font-style: normal;
      font-weight: 400;
      line-height: 140%;
    }
  }

  ._profile-mode-inner.cancel-sub {
    margin-bottom: 27px;

    ._profile-page-mode-info {
      padding-bottom: 44px;
    }

    ._profile-page-mode-confirm-title {
      margin-bottom: 33px;
      color: #333;
      font-size: 20px;
      font-family: Gilroy;
      font-weight: 700;
      line-height: 140%;
    }
  }

  ._profile-mode-inner.change-pass {
    padding-top: 65px;
  }

  ._profile-mode-inner.email-control {
    padding-top: 64px;

    ._profile-page-mode-info {
      padding-bottom: 44px;
    }

  }

  ._profile-mode-inner {
    margin-bottom: 40px;
    padding-top: 59px;

    ._profile-mode-input-group {
      margin-bottom: 10px;

      ._profile-mode-label {
        margin-bottom: 0;
        color: #828282;
        font-size: 12px;
        font-family: Circe;
        font-style: normal;
        font-weight: 400;
        line-height: 140%;
      }

      input {
        display: flex;
        text-align: center;
        width: 100%;
        padding: 14px;
        font-size: 16px;
        font-family: Gilroy;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 8px;
        border: 1px solid #22B491;
        outline: none;
        box-shadow: none;
        -webkit-appearance: none;
      }

      input::placeholder {
        color: #BDBDBD;
      }
    }

    ._profile-mode-input-group.mb35 {
      margin-bottom: 35px;
    }

    .enter-form-error {
      ._profile-mode-input {
        border: 1px solid #CF2F38;
      }
    }

    ._profile-go-to-mail {
      cursor: pointer;

      .btn-go-to-mail {
        width: 100%;
        height: 48px;
        padding-inline: 10px;
        margin-bottom: 10px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 8px;
        border: 1px solid #4F4F4F;

        span {
          color: #4F4F4F;
          font-family: Gilroy;
          font-size: 14px;
          font-style: normal;
          font-weight: 600;
          line-height: 140%;
        }
      }
    }

    ._profile-payments {
      margin-bottom: 0px;
      width: 100vw;
      margin-left: calc((100vw - 288px)/-2);
      display: flex;
      justify-content: center;

      ._profile-payment {
        width: 152px;
        height: 217px;
        border-radius: 8px;
        font-family: Gilroy;
        font-style: normal;
        cursor: pointer;

        &-header {
          position: relative;
          margin-bottom: 20px;

          b {
            font-size: 18px;
            font-weight: 500;
            line-height: normal;
          }

          img {
            position: absolute;
            top: 3px;
            right: 0;
          }
        }

        ._profile-payment-img {
          display: flex;
          align-self: end;
          width: 95px;
          height: 95px;
          margin-bottom: 20px;
        }

        span {
          font-size: 11px;
          font-weight: 400;
          line-height: 12px;
        }

        ._profile-payment-grey {
          padding-inline: 11px 13px;
          padding-block: 6px 9px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          color: #333;
          background-color: #F2F2F2;
          border-radius: 8px;
          border: 2px solid #22B491;
        }

        ._profile-payment-green {
          padding-inline: 11px 13px;
          padding-block: 6px 9px;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          color: #F2F2F2;
          background-color: #22B491;
          border-radius: 8px;
        }
      }

      ._profile-payment:first-child {
        margin-right: 10px;
      }

      ._profile-payment-mobile {
        ._profile-payment-img {
          align-self: start;
          width: 70px;
          height: 70px;
        }
      }
    }

  }

  ._profile-column-title {
    display: none;
  }

  ._profile-mode-inner-success {
    padding-top: 190px;
    text-align: center;
    flex: 1 0 auto;

    ._profile-mode-inner-success-card {
      width: 288px;
      height: 170px;
      margin: 0 auto 107px;
      padding: 26px 0 36px;
      border-radius: 8px;
      background: #E4EEFF;

      ._profile-mode-inner-success-image {
        margin-bottom: 20px;
      }

      ._profile-mode-inner-success-title {
        color: #2F80ED;
        text-align: center;
        font-size: 20px;
        font-family: Gilroy;
        font-weight: 700;
        line-height: 140%;
      }
    }
  }

  ._profile-mode-footer-wrapper {
    width: 272px;
    margin: 0 auto;
    border-top: 1px solid #F5F5F5;
    padding-top: 20px;
    text-align: center;

    a {
      margin-bottom: 20px;
    }

    p {
      color: #828282;
      font-size: 10px;
      font-family: Circe;
      font-style: normal;
      font-weight: 400;
      line-height: 110%;
    }
  }

  ul._profile-nav {
    li {
      height: 19px;
    }
  }
}
</style>
